<template>
  <b-form @submit.prevent>
    <b-row>
      <b-col md="6">
        <b-form-group
            label="Libellé"
            label-for="libelle"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.libelle}"
              v-model="groupe.libelle"
              id="libelle"
              placeholder="Nom du groupe"
          />
          <small v-if="form_errors.libelle" class="text-danger">{{ form_errors.libelle[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            @click="submit"
        >
          Enregistrer
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'GroupeForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    initialGroupe: {
      default: false,
    }
  },
  methods: {
    submit() {
      let _this = this;
      _this.form_errors = {};
      this.$store.dispatch('groupeModule/groupeStore', this.groupe).then(function (response) {
        _this.$emit('submited', response);
        _this.$router.push('/groupes')
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          _this.form_errors = error.response.data.errors;
        }
      })
    },
  },
  created() {
    if (this.initialGroupe) {
      this.groupe = {...this.initialGroupe};
    }
  },
  data() {
    return {
      groupe: {
        libelle: '',
      },
      form_errors: {}
    }
  },
}
</script>
